import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import MagnifyOutIcon from '@wwt/shared/assets/icons/outline/magnify-minus.svg'

import { cn } from '@/shared/lib/cn'

import { Button } from './Button.tsx'

interface NotFoundProps {
	icon?: ReactNode
	title?: string
	text?: string
	button?: ReactNode
	className?: string
}

/**
 * Used for not found pages
 *
 * @author Vladyslav Vladinov
 */
export const NotFound = ({
	icon,
	button,
	title,
	text,
	className
}: NotFoundProps) => {
	const { t } = useTranslation('not-found')

	return (
		<section className={cn('flex items-center justify-center', className)}>
			<div className="flex w-full max-w-[25.5rem] flex-col items-center gap-6">
				{icon || <MagnifyOutIcon className="h-16 w-16" />}

				<div className="flex flex-col gap-4 text-center">
					<h2 className="ts-headline-2">{title || t('pageNotFound.title')}</h2>

					<p>{text || t('pageNotFound.text')}</p>
				</div>

				{button || (
					<Button
						className="w-full"
						asChild
						variant="default"
					>
						<Link to="/">{t('pageNotFound.button')}</Link>
					</Button>
				)}
			</div>
		</section>
	)
}
